// Direct import, not the @/shared/ui barrel: the barrel exports
// Notifications, which imports ProfileProvider, which imports this file —
// the barrel edge here would close an import cycle.
import SpinnerSan from '@/shared/ui/SpinnerSan';

export default function AuthOverlay({ text }: { text: string | null }) {
  return (
    <div
      role="status"
      className="fixed inset-0 z-50 flex items-center justify-center bg-background-main/70 backdrop-blur-sm"
    >
      <div className="flex flex-col items-center gap-l">
        <SpinnerSan size={120} />
        {text != null && text !== '' && (
          <div className="text-body-lg text-gray-text">{text}</div>
        )}
      </div>
    </div>
  );
}
